function sampleValueFor(propDef) {
  if (Array.isArray(propDef?.enum) && propDef.enum.length)
    return propDef.enum[0];
  switch (propDef?.type) {
    case 'number':
      return 42;
    case 'boolean':
      return true;
    // Record references take the record's id; a conversation's is the #number users see.
    case 'conversation':
    case 'contact':
    case 'agent':
    case 'inbox':
      return 123;
    case 'text':
    default:
      return 'example value';
  }
}

export function buildWebhookPayloadExample(eventName, eventSchema) {
  const properties = {};
  const schemaProps = eventSchema?.properties || {};
  Object.entries(schemaProps).forEach(([key, def]) => {
    properties[key] = sampleValueFor(def);
  });

  return {
    event_name: eventName || 'your_event_name',
    external_id: 'your-unique-id-123',
    occurred_at: '2026-05-03T12:34:56Z',
    properties,
  };
}
